import { CoreTextView } from '@core/widgets';
import { useTranslation } from '@libs/core';
import React from 'react';
import { TextStyle } from '../types/styles';
import { ButtonRowView } from '../widgets/Buttons/ButtonRowView';
import { SeparatorView } from '../widgets/Separator/SeparatorView';
import { PopupComponent } from '../widgets/UI/Popup/PopupComponent';

type TOfflinePopupProps = {
    onRetry?: () => void;
};

const OfflinePopup = ({ onRetry }: TOfflinePopupProps) => {
    const { t } = useTranslation();

    return (
        <PopupComponent
            withoutSeparator
            internalContent={
                <>
                    <CoreTextView
                        text={t('bs.internet.connection.restored.header', 'You are offline')}
                        styleProps={{ ...TextStyle.main, textAlign: 'center', margin: { right: 24, left: 24, bottom: 16, top: 32 } }}
                    />
                    <CoreTextView
                        text={t(
                            'bs.internet.connection.restored.message',
                            'To use Paysend, please connect to the internet. Your money and any transfers in progress are safe.\n\n' +
                                "Check that Airplane mode is off, then try switching between Wi-Fi and mobile data. If you're on mobile data, moving to an area with better signal can help.",
                        )}
                        styleProps={{
                            ...TextStyle.main,
                            main: 'var(--color-grey_72_lc)',
                            textAlign: 'center',
                            margin: { right: 24, left: 24, bottom: 64, top: 16 },
                        }}
                    />
                    <SeparatorView />
                    <ButtonRowView
                        key={'try-again'}
                        onClick={onRetry}
                        label={t('bs.internet.connection.restored.button.label', 'Try again')}
                        iconName={'ic_arrow_retry'}
                        margin={{ bottom: 16, top: 16 }}
                    />
                </>
            }
        />
    );
};

export default OfflinePopup;
